const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoMsExcel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.65,
    height: 50.3,
    viewBox: "0 0 53.65 50.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-ms-excel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2646",
    "data-name": "Grupo 2646"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1255",
    "data-name": "Caminho 1255",
    d: "M52,43.59H28.5a1.68,1.68,0,0,1-1.68-1.68V8.38A1.68,1.68,0,0,1,28.5,6.71H52a1.68,1.68,0,0,1,1.68,1.67V41.91A1.68,1.68,0,0,1,52,43.59Z",
    style: {
      fill: "#eceff1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1256",
    "data-name": "Caminho 1256",
    d: "M35.21,16.77H28.5a1.68,1.68,0,0,1,0-3.36h6.71a1.68,1.68,0,0,1,0,3.36Z",
    style: {
      fill: "#388e3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1257",
    "data-name": "Caminho 1257",
    d: "M35.21,23.47H28.5a1.68,1.68,0,0,1,0-3.35h6.71a1.68,1.68,0,0,1,0,3.35Z",
    style: {
      fill: "#388e3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1258",
    "data-name": "Caminho 1258",
    d: "M35.21,30.18H28.5a1.68,1.68,0,0,1,0-3.36h6.71a1.68,1.68,0,0,1,0,3.36Z",
    style: {
      fill: "#388e3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1259",
    "data-name": "Caminho 1259",
    d: "M35.21,36.88H28.5a1.68,1.68,0,0,1,0-3.35h6.71a1.68,1.68,0,0,1,0,3.35Z",
    style: {
      fill: "#388e3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1260",
    "data-name": "Caminho 1260",
    d: "M45.27,16.77H41.91a1.68,1.68,0,0,1-.08-3.36h3.44a1.68,1.68,0,0,1,.08,3.36Z",
    style: {
      fill: "#388e3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1261",
    "data-name": "Caminho 1261",
    d: "M45.27,23.47H41.91a1.68,1.68,0,0,1-.08-3.35h3.44a1.68,1.68,0,0,1,.08,3.35Z",
    style: {
      fill: "#388e3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1262",
    "data-name": "Caminho 1262",
    d: "M45.27,30.18H41.91a1.68,1.68,0,0,1-.08-3.36h3.44a1.68,1.68,0,0,1,.08,3.36Z",
    style: {
      fill: "#388e3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1263",
    "data-name": "Caminho 1263",
    d: "M45.27,36.88H41.91a1.68,1.68,0,0,1-.08-3.35h3.44a1.68,1.68,0,0,1,.08,3.35Z",
    style: {
      fill: "#388e3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1264",
    "data-name": "Caminho 1264",
    d: "M29.57.39A1.64,1.64,0,0,0,28.19,0l-26.82,5A1.67,1.67,0,0,0,0,6.71V43.59a1.68,1.68,0,0,0,1.37,1.65l26.82,5a1.68,1.68,0,0,0,2-1.33,1.66,1.66,0,0,0,0-.32V1.68A1.68,1.68,0,0,0,29.57.39Z",
    style: {
      fill: "#2e7e33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1265",
    "data-name": "Caminho 1265",
    d: "M23.05,30.75l-5.3-6.06,5.36-6.89a1.68,1.68,0,1,0-2.64-2.07l-5,6.39-4.18-4.78A1.68,1.68,0,0,0,8.7,19.43l.1.12,4.61,5.27-4.68,6A1.68,1.68,0,0,0,9,33.18a1.67,1.67,0,0,0,2.35-.3l4.28-5.5L20.53,33a1.67,1.67,0,1,0,2.6-2.11l-.08-.09Z",
    style: {
      fill: "#fbfbfb"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMsExcel);
export default __webpack_public_path__ + "static/media/ico-ms-excel.4a8a36ff281441e09ddc7f1a500089a6.svg";
export { ForwardRef as ReactComponent };